<template>
    <div class="p-6 mb-8 bg-white rounded-lg lg:p-8">
        <p class="mb-6 text-xl font-bold text-primary-500">VI. Allergies アレルギー</p>

        <div class="grid grid-cols-1 mb-10 lg:grid-cols-12 gap-x-8 gap-y-6">
            <div class="col-span-full">
                <p class="mb-2">Do you have any allergies? アレルギーはありますか：</p>
                <div class="grid grid-cols-1 space-y-2 lg:grid-cols-12">
                    <!-- <radio-group
                        :options="[
                            { id: 'no', label: 'No/いいえ', value: 'no'},
                            { id: 'yes', label: 'Yes/はい', value: 'yes'},
                        ]"
                        name="has_allergies"
                        customClass="col-span-6"
                        :is-disabled="disableInputs"
                        v-model="item.has_allergies"
                        :error="errors['allergies.has_allergies'] ? errors['allergies.has_allergies'][0] : ''"
                    />
                    <div class="col-span-6"></div> -->
                    
                    <!-- v-if="item.has_allergies === 'yes'" -->
                    <div 
                        class="col-span-full mt-6"
                    >
                        <p class="mb-4 text-gray-700">
                            Check if you are frequently experiencing any of the following / 次のいずれかの処置をうけたことがある場合には、下記のボックスにチェックを入れてください:
                        </p>
                        
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-3">
                            <!-- Left column -->
                            <div class="space-y-3">
                                <CheckboxInput
                                    v-for="option in leftColumnOptions"
                                    :key="option.key"
                                    v-model="item[option.key]"
                                    :disabled="disableInputs"
                                    :label="option.label"
                                    :rounded="false"
                                    :is-checked="item[option.key]"
                                />
                            </div>
                            
                            <!-- Right column -->
                            <div class="space-y-3">
                                <CheckboxInput
                                    v-for="option in rightColumnOptions"
                                    :key="option.key"
                                    v-model="item[option.key]"
                                    :disabled="disableInputs"
                                    :label="option.label"
                                    :rounded="false"
                                    :is-checked="item[option.key]"
                                />
                                
                                <div class="space-y-2">
                                    <CheckboxInput
                                        v-model="item.others"
                                        :disabled="disableInputs"
                                        label="Others/その他"
                                        :rounded="false"
                                        :is-checked="item.others"
                                    />
                                    
                                    <text-input
                                        v-if="item.others"
                                        id="others_specify"
                                        type="text"
                                        placeholder="Type here"
                                        :disabled="disableInputs"
                                        v-model="item.others_specify"
                                        :error="errors['allergies.others_specify'] ? errors['allergies.others_specify'][0] : ''"
                                        class="ml-7 mt-2"
                                    />
                                </div>
                            </div>
                        </div>
                        
                        <div class="mt-6">
                            <label class="block text-sm font-medium text-gray-700 mb-2">
                                Additional Notes (Please specify the food/medicine/other allergies): 追加の注意事項(食物・薬物・その他のアレルギーについて記載してください)
                            </label>
                            <textarea
                                :disabled="disableInputs"
                                v-model="item.additional_notes"
                                rows="4"
                                class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                :class="{
                                    'bg-gray-100': disableInputs,
                                    'border-red-500': errors['allergies.additional_notes']
                                }"
                            ></textarea>
                            <p
                                v-if="errors['allergies.additional_notes']"
                                class="text-[10px] mt-1 text-red-600"
                            >
                                {{ errors['allergies.additional_notes'][0] }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import TextInput from '@/components/inputs/TextInput.vue';
import RadioGroup from '@/components/inputs/RadioGroup.vue';
import CheckboxInput from '@/components/inputs/CheckboxInput.vue';
import { ref, watch, computed } from 'vue';

const props = defineProps({
    form: {
        type: Object,
        required: true
    },
    errors: {
        type: Array,
        required: true
    },
    disableInputs: {
        type: Boolean,
        default: false
    }
})

const item = ref(props.form)

const selectedVal = computed(() => item.value);

// watch(
//     () => item.value.has_allergies,
//     (val: string) => {
//         if (val === 'no') {
//             // Reset all allergy symptoms
//             item.value.itchy_skin = false;
//             item.value.rash_or_hives = false;
//             item.value.swelling = false;
//             item.value.itchy_eyes = false;
//             item.value.watery_eyes = false;
//             item.value.fatigue = false;
//             item.value.coughing = false;
//             item.value.shortness_of_breath = false;
//             item.value.sneezing = false;
//             item.value.runny_or_stuffy_nose = false;
//             item.value.others = false;
//             item.value.others_specify = null;
//             item.value.additional_notes = null;
//         }
//     }
// );

watch(
    () => item.value.others,
    (val: boolean) => {
        if (!val) {
            item.value.others_specify = null;
        }
    }
);

const leftColumnOptions = [
    { key: 'itchy_skin', label: 'Itchy skin' },
    { key: 'rash_or_hives', label: 'Rash or hives' },
    { key: 'swelling', label: 'Swelling' },
    { key: 'itchy_eyes', label: 'Itchy eyes' },
    { key: 'watery_eyes', label: 'Watery eyes' },
    { key: 'fatigue', label: 'Fatigue' },
];

const rightColumnOptions = [
    { key: 'coughing', label: 'Coughing' },
    { key: 'shortness_of_breath', label: 'Shortness of breath' },
    { key: 'sneezing', label: 'Sneezing' },
    { key: 'runny_or_stuffy_nose', label: 'Runny or stuffy nose' },
];
</script>